export default __webpack_public_path__ + "static/media/pdf.1ae7f5b6.png";